// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MediaSortController from "./media_sort_controller"
application.register("media-sort", MediaSortController)

import RepeaterController from "./repeater_controller"
application.register("repeater", RepeaterController)

import UppyUploadController from "./uppy_upload_controller"
application.register("uppy-upload", UppyUploadController)
